/* eslint-disable no-console */
import { checkboxStyles } from "@store/theme/common/mixins";
import polyfillCss from "@store/theme/common/polyfillCss";

export default {
    defaultProps: {
        color: "common.background",
        css: polyfillCss`
            ${checkboxStyles()}
        `,
        iconProps: {
            size: 12,
        },
    },
};
